import script from "./Publication.vue?vue&type=script&setup=true&lang=js"
export * from "./Publication.vue?vue&type=script&setup=true&lang=js"

import "./Publication.vue?vue&type=style&index=0&id=67670c64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67670c64"]])

export default __exports__